module.exports = __webpack_public_path__ + "assets/img/fryer_active.57927356.png";